var map = {
	"./american_express.svg": "b5d9",
	"./bank.svg": "b3e0",
	"./dankort.svg": "73f2",
	"./diners_club.svg": "16d2",
	"./discover.svg": "0aa2",
	"./forbrugsforeningen.svg": "98b7",
	"./jcb.svg": "c0ec",
	"./laser.svg": "8988",
	"./maestro.svg": "5883",
	"./master.svg": "82d0",
	"./solo.svg": "180c",
	"./switch.svg": "f5ad",
	"./visa.svg": "a5bd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab2f";